export const generateUniqueName = (
  nameGenerator: (prefix: string, i: number) => string,
  prefix: string,
  existingNames: string[],
  {
    allowNameWithoutSuffix = false,
    startIndex = 1,
    endIndex = 999,
  }: {
    allowNameWithoutSuffix?: boolean
    startIndex?: number
    endIndex?: number
  } = {},
): string => {
  const hasName = (name: string) =>
    !!existingNames.find(existingName => existingName === name)

  if (allowNameWithoutSuffix && !hasName(prefix)) {
    return prefix
  }

  for (let i = startIndex; i <= endIndex; ++i) {
    const possibleNewName = nameGenerator(prefix, i)

    if (!hasName(possibleNewName)) {
      return possibleNewName
    }
  }
  throw new Error(
    `Couldn't find a unique name for '${prefix}', where existing names: ${existingNames}`,
  )
}
